import type { ReactNode } from "react"

import { Button } from "../Button"
import { ButtonGroup } from "../ButtonGroup"
import { Icon } from "../Icon"
import { Text } from "../Text"
import { useGroupContext } from "./context"
import styles from "./GroupItem.module.css"

interface Props {
  index?: number
  title?: string
  onMove?: (params: { index: number; offset: number }) => void
  onDelete?: (params: { index: number }) => void
  children?: ReactNode
}

export function GroupItem(props: Props) {
  const { index = 0, title, onMove, onDelete, children } = props

  const { itemsCount } = useGroupContext()

  const canMoveItem = itemsCount > 1

  return (
    <article className={styles.root}>
      <header className={styles.header}>
        <Icon className={styles.headerIcon} name="viewDay" />
        <Text color="grey11" variant="small" component="span">
          {title}
        </Text>
        <ButtonGroup sx={{ marginLeft: "auto" }} size="small" color="grey">
          {canMoveItem && (
            <ButtonGroup density="compact">
              <Button
                disabled={index === 0}
                startIcon="arrowUpward"
                onClick={() => onMove?.({ index, offset: -1 })}
              />
              <Button
                disabled={index === itemsCount - 1}
                startIcon="arrowDownward"
                onClick={() => onMove?.({ index, offset: 1 })}
              />
            </ButtonGroup>
          )}
          <Button startIcon="delete" onClick={() => onDelete?.({ index })} />
        </ButtonGroup>
      </header>
      <section className={styles.content}>{children}</section>
    </article>
  )
}
